import { connect, MapStateToProps } from 'react-redux';
import { Props } from './BillingCyclePopup';
import {
  getPackages,
  getGiftUser,
  getSale,
} from '../../../../redux/packagePicker/selectors';

export type StateProps = Pick<Props, 'filteredPackages' | 'sale'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = (
  state,
  ownProps
) => {
  return {
    filteredPackages: getPackages(state)?.filter(p =>
      ownProps.selectedPackage?.includes(p.subproductId)
    ),
    giftUser: getGiftUser(state),
    sale: getSale(state),
  };
};

export default connect(mapStateToProps);
